import { render, staticRenderFns } from "./botonEnlace.vue?vue&type=template&id=40cb0982&scoped=true&"
import script from "./botonEnlace.vue?vue&type=script&lang=js&"
export * from "./botonEnlace.vue?vue&type=script&lang=js&"
import style0 from "./botonEnlace.vue?vue&type=style&index=0&id=40cb0982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cb0982",
  null
  
)

export default component.exports